"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.progress.title': 'Model Training',
    'trainer.progress.start': 'Start Training',
    'trainer.progress.stop': 'Stop Training',
    'trainer.progress.new': 'New Training',
    'trainer.progress.title.text': 'Training Progress',
    'trainer.progress.metric.epoch': 'Current Epoch:',
    'trainer.progress.metric.loss': 'Loss:',
    'trainer.progress.metric.accuracy': 'Accuracy:',
    'trainer.progress.metric.time': 'Time Remaining:',
    'trainer.progress.preparing': 'Preparing training data...',
    'trainer.progress.started': 'Training started...',
    'trainer.progress.training.epoch': 'Training epoch {current}/{total}...',
    'trainer.progress.completed': 'Training completed successfully!',
    'trainer.progress.error.starting': 'Error starting training:',
    'trainer.progress.warn.noId': 'No training ID available for job completion',
    'trainer.progress.model.created': 'Custom model created successfully:',
    'trainer.progress.model.available': 'Training completed! Custom model "{name}" is now available.',
    'trainer.progress.error.model': 'Failed to create custom model:',
    'trainer.progress.error.completion': 'Error handling job completion:',
    'trainer.progress.warn.noIdError': 'No training ID available for error handling',
    'trainer.progress.job.failed': 'Job marked as failed in database',
    'trainer.progress.error.handling': 'Error handling job failure:',
};
